/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateKnownIssueDto interface.
 */
export function instanceOfUpdateKnownIssueDto(value) {
    return true;
}
export function UpdateKnownIssueDtoFromJSON(json) {
    return UpdateKnownIssueDtoFromJSONTyped(json, false);
}
export function UpdateKnownIssueDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'title': json['title'] == null ? undefined : json['title'],
        'content': json['content'] == null ? undefined : json['content'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
export function UpdateKnownIssueDtoToJSON(json) {
    return UpdateKnownIssueDtoToJSONTyped(json, false);
}
export function UpdateKnownIssueDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'title': value['title'],
        'content': value['content'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
    };
}
